<script setup>
import { provide, ref } from 'vue'
import { useElementSize } from '@vueuse/core'
import { num2k } from '@/utils'
import SharePanel from '../SharePanel/index.vue'

defineProps({
  size: { type: String, default: null },
  shareId: { type: [String, Number], default: null },
  isLike: { type: Boolean, default: false },
  likeNum: { type: Number, default: 0 }
})

const toolLeftRef = ref(null)
const { height: toolLHeight } = useElementSize(toolLeftRef)
const popover2Ref = ref()
provide('popover2Ref', popover2Ref)
</script>

<template>
  <tvb-affix
    :target="'.affix-container-wrap-' + shareId"
    :offset="184"
    zIndex="9"
    :placeholder="false"
    :rootSize="{ rootHeight: toolLHeight || 160, rootWidth: 1 }"
  >
    <div ref="toolLeftRef" class="tvb-article-tool-left">
      <div class="tool-item" :class="{ selected: isLike }">
        <div class="tool-icon-box tvb-hairline--surround" @click="$emit('like')">
          <tvb-svg-icon name="icon_article_like_grey" />
        </div>
        <p class="tool-text">{{ likeNum ? num2k(likeNum) : '點讚' }}</p>
      </div>
      <div class="tool-item">
        <div class="tool-share-wrap">
          <n-popover
            class="tvb-article-share_popover"
            trigger="hover"
            :show-arrow="false"
            placement="right-start"
            :to="false"
          >
            <template #trigger>
              <div class="tool-icon-box tvb-hairline--surround">
                <tvb-svg-icon name="icon_article_share" />
              </div>
            </template>
            <share-panel :size="size" :share-id="shareId"></share-panel>
          </n-popover>
        </div>
        <p class="tool-text">分享</p>
      </div>
    </div>
  </tvb-affix>
</template>

<style lang="scss" scoped>
// 左边工具栏
.tvb-article-tool-left {
  --tool-left-space: -32px;
  position: absolute;
  left: 0;
  transform: translateX(calc(-100% + var(--tool-left-space)));
  transition: transform 0.5s linear;
  // top: 16px + 34px;
  z-index: 2;

  @media screen and (max-width: 1460px) {
    --tool-left-space: -16px;
    &:hover {
      transform: translateX(-16px);
    }
  }
  @media screen and (max-width: 1200px) {
    --tool-left-space: -6px;
  }

  .tool-item {
    & + .tool-item {
      margin-top: 16px;
    }

    .tool-icon-box {
      width: 48px;
      height: 48px;
      font-size: 24px;
      background-color: #f8f9fa;
      border-radius: 50%;
      --tvb-hairline-border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
      cursor: pointer;
      user-select: none;
      transition:
        width 0.5s linear,
        height 0.5s linear,
        background-color 0.15s linear;

      &:hover {
        background-color: #fff;
        --icon_article_like_grey: #0062a3 !important;
        --icon_article_share: #0062a3 !important;
      }

      @media screen and (max-width: 1200px) {
        width: 40px;
        height: 40px;
      }
    }

    .tool-share-wrap {
      &:hover .tool-icon-box {
        background-color: #fff;
        --icon_article_like_grey: #0062a3 !important;
        --icon_article_share: #0062a3 !important;
      }
    }

    .tool-text {
      text-align: center;
      font-size: 14px;
      color: #555555;
      line-height: 20px;
    }

    &.selected {
      .tool-icon-box {
        --icon_article_like_grey: #0062a3 !important;
      }
      .tool-text {
        color: #0062a3;
      }
    }
  }
}

// 分享弹窗样式
:deep(.tvb-article-share_popover),
:deep(.tvb-article-share_popover-m) {
  --n-space: 12px !important;
  --n-padding: 0 !important;
  // --n-border-radius: 10px !important;
  --n-color: transparent !important;
  --n-box-shadow: none !important;
}
:deep(.tvb-article-share_popover-m) {
  --n-space: 6px !important;
  margin-right: var(--n-space);
}
</style>
